import React from "react";
import { Box, Container } from "@mui/material";
import ApiDocs from "../components/tools/ApiDocs";

const ApiDocsPage: React.FC = () => {
  return (
    <Container maxWidth={false} sx={{ py: 3, px: { xs: 1.5, md: 3 } }}>
      <Box>
        <ApiDocs />
      </Box>
    </Container>
  );
};

export default ApiDocsPage;
